"use strict";require("core-js/modules/es.array.filter");require("core-js/modules/es.array.for-each");require("core-js/modules/es.array.includes");require("core-js/modules/es.array.index-of");require("core-js/modules/es.array.some");require("core-js/modules/es.array.sort");require("core-js/modules/es.date.to-string");require("core-js/modules/es.object.keys");require("core-js/modules/es.string.includes");require("core-js/modules/web.dom-collections.for-each");exports.__esModule = true;exports.convertFromObj = convertFromObj;exports.convert = convert;exports.toCurrentTimezone = toCurrentTimezone;

var _is = require("../../is");


var _misc = require("../misc");
var _tsTo = require("./tsTo");
var _setters = require("../setters");
var _getters = require("../getters");
var _consts = require("../consts");






function convertFromObj(
dateObj,
dateToChange)
{
  var keys = Object.keys(dateObj);

  if (!keys.some(function (argKey) {return _consts.objDateKeys.includes(argKey);})) {
    console.error('argument for converting to object is invalid: ', dateObj);
    return null;
  }

  keys = keys.filter(function (objKey) {return _consts.objDateKeys.includes(objKey);});

  keys.sort(function (argKeyA, argKeyB) {
    var indA = _consts.objDateKeys.indexOf(argKeyA);
    var indB = _consts.objDateKeys.indexOf(argKeyB);
    return indA - indB;
  });

  var d = (0, _misc.isDate)(dateToChange) ? new Date(dateToChange) : (0, _getters.getNow)();

  keys.forEach(function (key) {
    (0, _setters.set)(d, key, Math.floor(dateObj[key]));
  });
  if (keys.includes('M')) {
    (0, _setters.set)(d, 'M', Math.floor(dateObj.M));
  }
  return d;
}



function convert(date) {
  if ((0, _is.isStr)(date)) {
    return (0, _getters.getDateFromStr)(date);
  }if ((0, _is.isNum)(date)) {
    return new Date((0, _tsTo.tsToMs)(date));
  }if ((0, _misc.isDate)(date)) {
    return new Date(date);
  }if ((0, _is.isObj)(date)) {
    return convertFromObj(date);
  }

  return null;
}

function toCurrentTimezone(date) {
  var parsedDate = convert(date);

  if ((0, _is.isNull)(parsedDate)) return parsedDate;

  var parsedDateWithOffset = parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60 * 1000;
  var newDate = new Date(parsedDateWithOffset);

  return convert(newDate);
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/convert/convert.js
// module id = 625
// module chunks = 0